// Third Party
import MostSearchedFund from '@/types/most-searched-fund';
import { AsyncResult, Action, ApiAction } from '../index';
import api from '../redux-api';

// Types
import { AnalyticsState } from './types/analytics';

// Initial state
const INITIAL_STATE: AnalyticsState = {
  mostSearchedFunds: [],
  loading: {
    mostSearchedFunds: false,
  },
};

// Actions
const GET_MOST_SEARCHED_FUNDS: ApiAction = {
  type: 'connect/analytics/most-searched',
  endpoint: 'analytics/most-searched',
};

// Reducer
export default function reducer(state: AnalyticsState = INITIAL_STATE, action: Action): AnalyticsState {
  switch (action.type) {
    case GET_MOST_SEARCHED_FUNDS.type: {
      return {
        ...state,
        mostSearchedFunds: [],
        loading: {
          ...state.loading,
          mostSearchedFunds: true,
        },
      };
    }
    case `${GET_MOST_SEARCHED_FUNDS.type}_SUCCESS`: {
      return {
        ...state,
        mostSearchedFunds: action.data.data.items,
        loading: {
          ...state.loading,
          mostSearchedFunds: false,
        },
      };
    }
    case `${GET_MOST_SEARCHED_FUNDS.type}_ERROR`: {
      return {
        ...state,
        loading: {
          ...state.loading,
          mostSearchedFunds: false,
        },
      };
    }
    default: {
      return state;
    }
  }
}

// Action Creators
export const getMostSearchedFunds = (): AsyncResult<MostSearchedFund[]> => () => api.get(GET_MOST_SEARCHED_FUNDS);
